import  { lazy } from 'react';

const feedbackPromise = import("./Feedback.js");
export default lazy(() => feedbackPromise);
